<template>
  <section>
    <button class="individual" @click="open()">
      <p>
        {{ $t("Individual_packages") }}
      </p>
      <v-icon icon="mdi-chevron-up" v-if="style"></v-icon>

      <v-icon icon="mdi-chevron-down" v-else></v-icon>
    </button>
    <div class="row" :class="[style ? 'showing' : 'hiding']">
      <v-card
          class="mt-5 pa-5  card_subscribe col-md-4"
          v-for="(int, i) in individual"
          :key="i"
      >
        <div class="row-one-item bg-grey-lighten-4">
          <v-card-title class="d-flex flex-sm-row flex-column justify-space-between font-weight-bold">
            <span>{{ int.name }}</span>

              <span class="package-price d-flex" style="margin-top: 10px">
                <span class="package-old-price d-flex" style="text-decoration: line-through;">
                    {{int.old_price}}  <v-img src="../../assets/icon/sr-w.png" :style="{ width: '20px', margin: '0 2px' }" class="px-2 iconbtn" ></v-img>
                </span>
                {{ int.price }}
              <v-img src="../../assets/icon/sr-w.png" :style="{ width: '20px', margin: '0 2px' }" class="px-2 iconbtn" ></v-img>
              </span>
          </v-card-title>
          <v-list  class="ps-sm-16 ps-0 ms-sm-15 ms-0 bg-grey-lighten-4 item-features">
            <v-list-item v-for="(pack, i) in int.features" :key="i">
              <v-list-item-title class="font-weight-medium">
                <v-icon icon="mdi-check-circle" class="text-green"></v-icon>
                {{ pack }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
          <div  v-if="is_login">
            <div class="d-flex flex-sm-row flex-column"  v-if="parsePrice(int.price) > 0">
              <v-text-field
                  density="compact"
                  variant="solo"
                  single-line
                  hide-details
                  class="rounded font-weight-medium w-75 me-sm-3 me-0 input_discount"
                  elevation="0"
                  :placeholder="$t('Discount')"
                  style="box-shadow: none"
                  v-model="coupon"
              >
              </v-text-field>
              <button

                  class="w-25 text-white mx-auto mt-sm-0 mt-2 pa-sm-0 pa-2 rounded send_code"
                  style="background-color: #f6c712"
                  @click="send(int)"
              >
                {{ $t("Send") }}
              </button>
            </div>
            <div class="text-red pt-2"  >{{ errorMessage ? errorMessage : "" }}</div>
          </div>

          <div class="text-center"  v-if="is_login">
            <button
                class="w-100 pa-sm-3 pa-1 rounded mt-sm-8 mt-3"
                style="border: 3px solid #d9d9d9; font-size: 23px"
                v-if="parsePrice(int.price) > 0"
                @click="dialog = true"
            >
              {{ $t("Payment_method") }}
            </button>
            <button
                class="w-75 mt-4 pa-2 rounded font-weight-bold"
                style="background-color: rgb(229 214 157)"
                @click="subscriptionStore(int.id,parsePrice(int.price))"
            >
              {{ $t("Subscribe_now") }}
            </button>
          </div>

          <v-dialog width="800"  v-if="is_login" v-model="dialog">
            <v-card class="form_select pa-3">
              <v-card-title class="text-center text-h5 mb-5 font-weight-bold">
                {{ $t("Payment_method") }}
              </v-card-title>
              <v-form @submit.prevent="saveselect" enctype="multipart/form-data">
                <v-checkbox
                    v-model="selected"
                    :label="$t('Electronic_payment')"
                    value="0"
                    @change="changefile()"
                ></v-checkbox>
                <v-checkbox
                    v-model="selected"
                    :label="$t('Bank')"
                    value="1"
                    @change="changefile()"
                ></v-checkbox>
                <div v-if="imagefile"
                     class=" justify-center rounded elevation-2 mb-3"
                     style="display: grid;"
                >
                  <input
                      ref="file"
                      accept=".pdf, image/jpeg, image/png"
                      type="file"
                      class="pa-5 w-100"
                      @change="handleFileChange"
                  />
                </div>

                <v-btn
                    class="w-100 elevation-0  font-weight-bold"
                    style="background-color: rgb(229 214 157)"
                    type="submit"
                >
                  {{ $t("Save") }}
                </v-btn>
              </v-form>
            </v-card>
          </v-dialog>
        </div>

      </v-card>
    </div>
  </section>
</template>
<script>
import crudDataService from "@/Services/crudDataService";
import axios from "axios";
export default {
  data() {
    return {
      is_login: false,
      style: false,
      individual: [],
      coupon: "",
      errorMessage: "",
      selected: null,
      dialog: false,
      selectedFile: null,
      imagefile: false,
    };
  },

  methods: {
    parsePrice(price){
      if (!price) return 0;
      return parseFloat(price.replace(/,/g, ''));

    },
    handleFileChange(event) {
      this.selectedFile = event.target.files.item(0);
    },
    changefile() {
      if (this.selected == 1) {
        this.imagefile = !this.imagefile;
      }
    },

    saveselect() {
      this.dialog = false;
    },
    open() {
      this.style = !this.style;
    },
    async send(obj) {
      await crudDataService
        .create(`coupons/check`, {
          coupon: this.coupon,
          price: obj.price,
          subscription_id: obj.id,
        })
        .then((res) => {
          if (res.data.success){
            this.$swal.fire({
              title: res.data.message,
              position: "top-start",
              showCancelButton: false,
              showConfirmButton: false,
              timer: 1500,
              icon: "success",
              customClass: {
                icon: "my-custom-class",
                title: "swal2-title",
              },
            });
          }

          // console.log(res.data.data, "wdjqpowjpwd");
        })
        .catch((error) => {
          this.errorMessage = error.response.data.message;
        });
    },
    async package() {
      const id = localStorage.getItem("authToken");
      this.is_login = id!= null;
      let response = await crudDataService.getAll(`subscriptions`);
      response.data.data.forEach((element) => {
        if (element.premium == 0) {
          this.individual.push(element);
        }
      });
    },

    async subscriptionStore(id ,price) {

      let form = new FormData();
      if(price > 0){

        if (this.selected == 1) {
          form.append("receipt", this.selectedFile);
        }
        form.append("subscription_id", id);
          form.append("payment_id", this.selected);
          form.append("coupon", this.coupon);
          form.append("payment_method", "online");
        try {
          let res = await crudDataService.create(`subscription/store`, form, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });


          if (res.data.success) {
            this.coupon='';
            if (res.data.data.url != null) {
              window.location.href = res.data.data.url;

            }else {
              this.$swal.fire({
                title: res.data.message,
                position: "top-start",
                showCancelButton: false,
                showConfirmButton: false,
                timer: 1500,
                icon: "success",
                customClass: {
                  icon: "my-custom-class",
                  title: "swal2-title",
                },
              });
            }
          }
        } catch (error) {
          this.$swal.fire({
            text: error.response.data.message ,
            icon: "error",
            position: "top-start",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1000,

            customClass: {
              icon: "my-custom-class",
              title: "swal2-title",
            },
          });
        }
      }else {
        try {
          form.append("subscription_id", id);

          let res = await crudDataService.create(`subscription/store-free`, form, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
          if (res.data.success){
            this.$swal.fire({
              title: res.data.message,
              position: "top-start",
              showCancelButton: false,
              showConfirmButton: false,
              timer: 1500,
              icon: "success",
              customClass: {
                icon: "my-custom-class",
                title: "swal2-title",
              },
            });
          }else{
            this.errorMessage = res.data.message;
          }
        } catch (error) {
          this.$swal.fire({
            text: error.response.data.message ,
            icon: "error",
            position: "top-start",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1000,

            customClass: {
              icon: "my-custom-class",
              title: "swal2-title",
            },
          });
        }


      }
    },
  },
  mounted() {
    this.package();
  },
};
</script>
<style lang="scss">
.form_select {
  .v-selection-control__wrapper {
    display: none;
  }
  .carddata .subtitle {
    font-size: 15px;
    margin-top: auto;
  }
  .v-checkbox .v-selection-control {
    padding-right: 5px;
    padding-left: 5px;
    border: 2px solid #f6c712;
    border-radius: 4px;
    justify-content: center;
  }
  .v-label--clickable {
    cursor: pointer;
    font-size: 18px;
    color: #000;
    font-weight: 700;
    width: 100%;
    justify-content: center;
  }
  .v-label {
    opacity: 1;
  }
}
.swal2-popup.swal2-show.swal2-modal.swal2-icon-error , .swal2-popup.swal2-show.swal2-modal.swal2-icon-success {
  height: 140px;
}


span.package-old-price.d-flex {
  text-decoration: line-through;
  font-size: 14px;
  margin: 0 10px;
  position: absolute;
  top: 10px;
  left: 10%;
}
.card_subscribe .v-input--density-compact .v-field--variant-outlined,
.card_subscribe .v-input--density-compact .v-field--single-line,
.card_subscribe .v-input--density-compact .v-field--no-label {
  box-shadow: none;
  background: transparent;
  border: 3px solid #d9d9d9 !important;
}
@media (max-width: 599.9px) {
  .card_subscribe .send_code,
  .card_subscribe .input_discount {
    width: 100% !important;
  }
}
</style>
<style lang="scss" scoped>
.card_subscribe {
  .v-text-field input.v-field__input {
    padding: 20px;
  }
}
.send_code {
  font-size: 22px;
}
.individual {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 2px solid #f6c712;
  width: 100%;
  border-radius: 5px;
  padding: 15px;
  font-weight: 500;
  font-size: 22px;
}
.row.showing {
  display: inline-flex;
  width: 100%;
}
.row-one-item {
  border: 1px solid rgba(0, 0, 0, 0.0784313725);
  border-radius: 15px;
  padding: 2px !important;
  height: 100%;
}
.v-card-title.d-flex.flex-sm-row.flex-column.justify-space-between.font-weight-bold {
  background-color: rgb(39 51 64 / 57%);
  border-radius: 5px;
  color: #fff;
}
span.package-price {
  color: #ffb100;
}
.item-features{
  padding: 5px !important;
  margin: 0 !important;
}

.v-card.v-theme--light.v-card--density-default.v-card--variant-elevated.mt-5.pa-5.card_subscribe.col-md-4 {
  background: none !important;
  border: none !important;
  padding: 8px !important;
  box-shadow: none !important;
}

.send_code {
  font-size: 22px;
  background-color: rgba(165, 135, 21, 0.231372549) !important;
  color: #505050 !important;
  border: 1px solid rgb(165 130 0 / 23%) !important;
}
.hiding {
  display: none;
}
.showing {
  display: block;
}
</style>
